import { useLazyGetUserQuery } from '../../api/userDetails';
import { useDispatch } from 'react-redux';
import { setUser } from '../../stores/User/slice';
import { setAccessRequestInfo } from '../../stores/UserAccess/slice';
import { USER_APPROVAL_STATUS } from '../../constants/constants';

const useUserDetails = () => {
  const [getUser, { isLoading, isError }] = useLazyGetUserQuery();
  const dispatch = useDispatch();

  const getUserDetails = async () => {
    try {
      const response = await getUser({}).unwrap();

      if (response.data) {
        dispatch(setUser(response.data));
        dispatch(setAccessRequestInfo(null));

        return response.data;
      }
    } catch (err) {
      const detailedError = (err as any)?.detailedErrorObject;
      const errorCode = detailedError?.code;
      const errorMessage = detailedError?.message;
      const errorData = detailedError?.data ?? null;

      if (errorCode === 4103) {
        dispatch(
          setAccessRequestInfo({
            code: errorCode,
            message: errorMessage,
            status: USER_APPROVAL_STATUS.PENDING_OWNER_APPROVAL,
            data: errorData,
          }),
        );

        return { accessStatus: USER_APPROVAL_STATUS.PENDING_OWNER_APPROVAL };
      }

      if (errorCode === 4116) {
        if (errorData?.status === USER_APPROVAL_STATUS.COMPANY_CREATION_REQUESTED) {
          dispatch(
            setAccessRequestInfo({
              code: errorCode,
              message: errorMessage,
              status: USER_APPROVAL_STATUS.COMPANY_CREATION_REQUESTED,
              data: errorData,
            }),
          );

          return { accessStatus: USER_APPROVAL_STATUS.COMPANY_CREATION_REQUESTED };
        }
        dispatch(
          setAccessRequestInfo({
            code: errorCode,
            message: errorMessage,
            status: USER_APPROVAL_STATUS.USER_PENDING_WORKSPACE_SETUP,
            data: errorData,
          }),
        );

        return { accessStatus: USER_APPROVAL_STATUS.USER_PENDING_WORKSPACE_SETUP };
      }

      if (errorCode === 4104) {
        dispatch(
          setAccessRequestInfo({
            code: errorCode,
            message: errorMessage,
            status: USER_APPROVAL_STATUS.REJECTED,
            data: null,
          }),
        );

        return { accessStatus: USER_APPROVAL_STATUS.REJECTED };
      }

      console.error('Error while fetching user :', err);
    }
  };

  return { getUserDetails, isLoading, isError };
};

export default useUserDetails;
